import { isObjectEmpty } from './isObjEmpty';

export function filterFalsyDataValues(
	data: any,
	takeZero: boolean = true,
): any {
	if (Array.isArray(data)) {
		return filterArrayValues(data);
	}

	return isObject(data)
		? Object.keys(data)
				.filter(
					(k) => !!data[k] || (takeZero && data[k] === 0) || data[k] === false,
				)
				.reduce((newObj, k) => {
					const val = data[k];
					if (isObject(val)) {
						const nested = filterFalsyDataValues(val);
						if (isObjectEmpty(nested)) {
							return newObj;
						}
						return { ...newObj, [k]: nested };
					}
					if (Array.isArray(val)) {
						const res = filterArrayValues(val);
						if (!res) {
							return newObj;
						}
						return { ...newObj, [k]: res };
					}
					return { ...newObj, [k]: val };
				}, {})
		: data;
}

function filterArrayValues<T>(arr: Array<T>) {
	if (!arr.length) {
		return false;
	}
	return arr.map((el) => filterFalsyDataValues(el));
}

function isObject(obj: any) {
	return (
		(!Array.isArray(obj) && typeof obj === 'object' && obj !== null) ||
		typeof obj === 'function'
	);
}
